import React from 'react';
import { Button, ButtonProps } from '@mui/material';

interface SecondaryButtonProps extends ButtonProps {
  // Any additional props specific to SecondaryButton can be added here
}

const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: 'transparent',
        color: 'black',
        border: '1px solid #ccc',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: 'transparent',
          border: '1px solid black',
        },
        ...sx // Allow overriding styles when needed
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;